const isInRange = (value, limit) => {
  if (typeof value === 'string' && value.trim() === '') {
    return false
  }
  if (typeof value !== 'number' && typeof value !== 'string') {
    return false
  }
  const number = Number(value)
  return Number.isFinite(number) && Math.abs(number) <= limit
}

export const formatLonlat = (position) => {
  if (!position) {
    return ''
  }
  const { longitude, latitude } = position
  if (!isInRange(longitude, 180) || !isInRange(latitude, 90)) {
    return ''
  }
  return `${longitude},${latitude}`
}

export const parseLonlat = (lonlat) => {
  if (typeof lonlat !== 'string') {
    return null
  }
  const [longitude, latitude] = lonlat.split(',')
  const position = { longitude, latitude }
  return formatLonlat(position) ? position : null
}

// Resolves null after `delay` ms so a slow GPS fix never blocks the alert
export const withTimeout = (promise, delay) => {
  let timer
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => resolve(null), delay)
  })
  return Promise.race([
    Promise.resolve(promise).catch(() => null),
    timeout
  ]).finally(() => clearTimeout(timer))
}

export const buildAlertDetailsDialog = (
  t,
  { withoutPosition = false } = {}
) => {
  const dialog = {
    title: `${t('report.accuracy')} :`,
    prompt: {
      type: 'textarea',
      label: `${t('issueDetails.sendByEmail.body')}...`,
      model: ''
    },
    ok: t('issueDetails.send'),
    cancel: t('common.cancel')
  }
  if (!withoutPosition) {
    return dialog
  }
  return {
    ...dialog,
    title: t('notification.categories.alertWithoutPosition.title'),
    message: t('notification.categories.alertWithoutPosition.message'),
    prompt: {
      ...dialog.prompt,
      label: `${t('issueDetails.sendByEmail.body')}...`
    }
  }
}
